export const SITE_URL = 'https://dezoom.eu';
export const OG_IMAGE = `${SITE_URL}/icons/icon-512.png`;

export interface RouteSeoEntry {
  titleKey: string;
  descriptionKey: string;
}

/** Public routes with unique meta (i18n keys). */
export const PUBLIC_SEO: Record<string, RouteSeoEntry> = {
  '/': {
    titleKey: 'seo.home.title',
    descriptionKey: 'seo.home.description',
  },
  '/decouvrir': {
    titleKey: 'seo.discover.title',
    descriptionKey: 'seo.discover.description',
  },
  '/comment-jouer': {
    titleKey: 'seo.howTo.title',
    descriptionKey: 'seo.howTo.description',
  },
  '/premium': {
    titleKey: 'seo.premium.title',
    descriptionKey: 'seo.premium.description',
  },
  '/credits': {
    titleKey: 'seo.credits.title',
    descriptionKey: 'seo.credits.description',
  },
  '/contact': {
    titleKey: 'contact.title',
    descriptionKey: 'seo.contact.description',
  },
  '/cgu': {
    titleKey: 'legal.cgu.title',
    descriptionKey: 'seo.legal.cguDescription',
  },
  '/cgv': {
    titleKey: 'legal.cgv.title',
    descriptionKey: 'seo.legal.cgvDescription',
  },
  '/mentions-legales': {
    titleKey: 'legal.mentions.title',
    descriptionKey: 'seo.legal.mentionsDescription',
  },
  '/confidentialite': {
    titleKey: 'legal.privacy.title',
    descriptionKey: 'seo.legal.privacyDescription',
  },
};

const NO_INDEX_PREFIXES = [
  '/play',
  '/archives',
  '/leaderboard',
  '/top',
  '/result',
  '/login',
  '/auth/',
  '/profile',
  '/admin',
  '/friends',
];

export function isNoIndexPath(pathname: string): boolean {
  return NO_INDEX_PREFIXES.some(
    (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`),
  );
}

export function canonicalUrl(pathname: string): string {
  const path = pathname === '/' ? '' : pathname.replace(/\/$/, '');
  return `${SITE_URL}${path}`;
}

export const HOME_JSON_LD = {
  '@context': 'https://schema.org',
  '@type': 'WebApplication',
  name: 'Dezoom',
  url: SITE_URL,
  applicationCategory: 'GameApplication',
  operatingSystem: 'Web',
  offers: {
    '@type': 'Offer',
    price: '0',
    priceCurrency: 'EUR',
  },
  description:
    'Jeu photo quotidien gratuit : devine le mot derrière une image zoomée. Chaque erreur dézoome la photo.',
};
